export default {
  allAppraisals: [],
}
